import { SvgIconProps } from '@mui/material';

export const FeaturedError = (props: SvgIconProps) => {
  return (
    <svg {...props} fill="none"  viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
      <circle cx="28" cy="28" fill="#FEF3F2" r="28"/>
      <circle cx="28" cy="28" fill="#FEE4E2" r="20"/>
      <path clipRule="evenodd" d="M21.2929 21.2929C21.6834 20.9024 22.3166 20.9024 22.7071 21.2929L28 26.5858L33.2929 21.2929C33.6834 20.9024 34.3166 20.9024 34.7071 21.2929C35.0976 21.6834 35.0976 22.3166 34.7071 22.7071L29.4142 28L34.7071 33.2929C35.0976 33.6834 35.0976 34.3166 34.7071 34.7071C34.3166 35.0976 33.6834 35.0976 33.2929 34.7071L28 29.4142L22.7071 34.7071C22.3166 35.0976 21.6834 35.0976 21.2929 34.7071C20.9024 34.3166 20.9024 33.6834 21.2929 33.2929L26.5858 28L21.2929 22.7071C20.9024 22.3166 20.9024 21.6834 21.2929 21.2929Z" fill="#D92D20" fillRule="evenodd"/>
    </svg>
  );
};
